<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import simplebar from "simplebar-vue";
import { getPackages } from "../../../../api/services/package.service";
import { getSubPackages } from "../../../../api/services/sub-package.service";
import { getAddOns } from "../../../../api/services/addon.service";
import {
	getBookings,
	getTotalAmountEarnedFromBooking,
} from "../../../../api/services/booking.service";
import { getTotalAmountEarnedFromVouchers } from "../../../../api/services/voucher.service";
import { getBookingAsEvents } from "../../bookings/booking-controller";
/**
 * Ms Sissi Dashboard Component
 */
export default {
	page: {
		title: "Übersicht",
		meta: [
			{
				name: "description",
				content: appConfig.description,
			},
		],
	},
	components: {
		Layout,
		PageHeader,
		simplebar,
	},
	data() {
		return {
			title: "Übersicht",
			items: [
				{
					text: "Übersicht",
					active: true,
				},
			],
			numberOfPackages: 0,
			numberOfSubpackages: 0,
			numberOfExtras: 0,
			totalAmountEarnedByBookings: 0,
			totalAmountEarnedByVouchers: 0,
			todayBookings: [],
		};
	},
	async mounted() {
		await this.getPackageCount();
		await this.getSubpackageCount();
		await this.getExtraCount();
		await this.getTotalAmoutFromBookings();
		await this.getTotalAmoutFromVouchers();
		await this.getBookingsForToday();
	},
	methods: {
		pushToPackages() {
			this.$router.push("/manage-packages");
		},
		pushToSubPackages() {
			this.$router.push("/manage-subpackages");
		},
		pushToExtras() {
			this.$router.push("/manage-extras");
		},
		pushToBooking() {
			this.$router.push("/manage-bookings");
		},
		async getPackageCount() {
			let allPackagesFromDatabase = await getPackages();
			if (allPackagesFromDatabase) {
				this.numberOfPackages = allPackagesFromDatabase.length;
			}
		},
		async getSubpackageCount() {
			let allSubpackagesFromDatabase = await getSubPackages();
			if (allSubpackagesFromDatabase) {
				this.numberOfSubpackages = allSubpackagesFromDatabase.length;
			}
		},
		async getExtraCount() {
			let allExtrasFromDatabase = await getAddOns();
			if (allExtrasFromDatabase) {
				this.numberOfExtras = allExtrasFromDatabase.length;
			}
		},
		async getTotalAmoutFromBookings() {
			let getTotalAmoutFromBookingsFromDatabase = await getTotalAmountEarnedFromBooking();
			if (getTotalAmoutFromBookingsFromDatabase) {
				this.totalAmountEarnedByBookings = getTotalAmoutFromBookingsFromDatabase;
			}
		},
		async getTotalAmoutFromVouchers() {
			let getTotalAmoutFromVouchers = await getTotalAmountEarnedFromVouchers();
			if (getTotalAmoutFromVouchers) {
				this.totalAmountEarnedByVouchers = getTotalAmoutFromVouchers;
			}
		},
		async getBookingsForToday() {
			let getAllBookings = await getBookings();
			let getAllBookingEvents = getBookingAsEvents(getAllBookings);
			const todayDateAndTime = new Date();
			if (todayDateAndTime.getHours() === 0) {
				todayDateAndTime.setHours(todayDateAndTime.getHours() + 1);
			}
			const todayDate = todayDateAndTime.toISOString().slice(0, 10);
			const tomorrowDate =
				todayDateAndTime.toISOString().slice(0, 8) +
				(todayDateAndTime.getDate() + 1);
			for (let i = 0; i < getAllBookingEvents.length; i++) {
				if (
					todayDate === getAllBookingEvents[i].start.slice(0, 10) ||
					tomorrowDate === getAllBookingEvents[i].start.slice(0, 10)
				) {
					this.todayBookings.push(getAllBookingEvents[i]);
				}
			}
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-lg-12">
				<div class="card">
					<div class="card-body">
						<div class="row">
							<div class="col-lg-4">
								<div class="media">
									<div class="mr-3">
										<img
											src="@/assets/images/users/avatar-1.jpg"
											alt
											class="avatar-md rounded-circle img-thumbnail"
										/>
									</div>
									<div class="media-body align-self-center">
										<div class="text-muted">
											<p class="mb-2">Willkommen zurück</p>
											<h5 class="mb-1">MS Sissi Administrator</h5>
										</div>
									</div>
								</div>
							</div>

							<div class="col-lg-4 align-self-center">
								<div class="text-lg-center mt-4 mt-lg-0">
									<div class="row">
										<div class="col-4">
											<div>
												<p class="text-muted text-truncate mb-2">Themen</p>
												<h5 class="mb-0">{{ numberOfPackages }}</h5>
											</div>
										</div>
										<div class="col-4">
											<div>
												<p class="text-muted text-truncate mb-2">Erlebnisse</p>
												<h5 class="mb-0">{{ numberOfSubpackages }}</h5>
											</div>
										</div>
										<div class="col-4">
											<div>
												<p class="text-muted text-truncate mb-2">Extras</p>
												<h5 class="mb-0">{{ numberOfExtras }}</h5>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="col-lg-4 d-none d-lg-block">
								<div class="clearfix mt-4 mt-lg-0">
									<b-dropdown class="float-right" right variant="primary">
										<template v-slot:button-content>
											<i class="bx bx-plus align-middle mr-1"></i>
											Erstellen
										</template>
										<b-dropdown-item @click="pushToPackages()"
											>Themen</b-dropdown-item
										>
										<b-dropdown-item @click="pushToSubPackages()"
											>Erlebnisse</b-dropdown-item
										>
										<b-dropdown-item @click="pushToExtras()"
											>Extras</b-dropdown-item
										>
									</b-dropdown>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-xl-6">
				<div class="card">
					<div class="row">
						<div class="col-7">
							<div class="text-primary p-3">
								<h5 class="text-primary">Buchungen</h5>
								<p>alle Buchungen ab heute</p>
							</div>
						</div>
						<div class="col-5 text-right pt-3 pr-4">
							<b-button @click="pushToBooking()" variant="primary">
								<i class="bx bx-bookmark bx-tada mr-1"></i>
								{{ $t("booking.header.item") }}</b-button
							>
						</div>
						<div class="mb-2 col-md-12">
							<div class="row" v-if="this.todayBookings.length === 0">
								<div class="col-md-12 text-center">
									<h5 class="subPackage">
										<i class="bx bx-sad bx-tada mr-2"></i>Keine Buchungen heute
									</h5>
								</div>
							</div>
							<div v-else class="row p-2">
								<div class="col-md-12">
									<ul class="list-group">
										<simplebar style="max-height: 225px">
											<li
												class="list-group-item"
												v-for="(booking, bookingIndex) in this.todayBookings"
												:key="bookingIndex"
											>
												<div class="row">
													<!-- booking title -->
													<div class="col-md-4">
														<label>
															<i
																class="bx bx-notification font-size-16 align-middle mr-1"
															></i
															>{{ $t("booking.editBooking.bookingTitle") }}:
														</label>
													</div>
													<div class="col-md-8">
														{{ booking.title }}
														<span
															v-if="booking.extendedProps.type === 'GENERAL'"
														>
															{{ booking.extendedProps.subPackage.title }}
														</span>
													</div>
													<!-- booking Starting Time -->
													<div class="col-md-4">
														<label>
															<i
																class="bx bx-time font-size-16 align-middle mr-1"
															></i>
															{{
																$t("booking.editBooking.bookingStratingTime")
															}}:
														</label>
													</div>
													<div class="col-md-8">
														{{
															booking.extendedProps.startTime.slice(11, 13)
														}}:{{
															booking.extendedProps.startTime.slice(14, 16)
														}}
													</div>
													<!-- booking Ending Time -->
													<div class="col-md-4">
														<label>
															<i
																class="bx bx-time-five font-size-16 align-middle mr-1"
															></i>
															{{ $t("booking.editBooking.bookingEndingTime") }}:
														</label>
													</div>
													<div class="col-md-8">
														{{ booking.extendedProps.endTime.slice(11, 13) }}:{{
															booking.extendedProps.endTime.slice(14, 16)
														}}
													</div>
													<!-- booking Status -->
													<div class="col-md-4">
														<label>
															<i
																class="bx bx-food-tag font-size-16 align-middle mr-1"
															></i
															>{{ $t("booking.editBooking.bookingStatus") }}:
														</label>
													</div>
													<div class="col-md-8">
														<b-badge
															v-if="booking.extendedProps.status === 'PENDING'"
															class="mr-1 font-size-12"
															variant="warning"
														>
															{{ $t("booking.bookingTypes.pending") }}
														</b-badge>
														<b-badge
															v-if="
																booking.extendedProps.status === 'CONFIRMED'
															"
															class="mr-1 font-size-12"
															variant="success"
														>
															{{ $t("booking.bookingTypes.confirmed") }}
														</b-badge>
														<b-badge
															v-if="booking.extendedProps.status === 'REJECTED'"
															class="mr-1 font-size-12"
															variant="danger"
														>
															{{ $t("booking.bookingTypes.rejected") }}
														</b-badge>
														<b-badge
															v-if="
																booking.extendedProps.status === 'CANCELLED'
															"
															class="mr-1 font-size-12"
															variant="danger"
														>
															{{ $t("booking.bookingTypes.rejected") }}
														</b-badge>
													</div>
												</div>
											</li>
										</simplebar>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xl-6">
				<div class="row">
					<div class="col-sm-6">
						<div class="card">
							<div class="card-body">
								<div class="d-flex col-md-12 mb-3 text-center">
									<div class="avatar-xs mr-3">
										<span
											class="avatar-title rounded-circle bg-success text-primary font-size-18"
										>
											<i class="bx bx-euro bx-tada"></i>
										</span>
									</div>
									<h5 class="font-size-14 mt-2 mb-0">Buchungsumsatz</h5>
								</div>
								<div class="mt-2">
									<div class="col-md-12 text-center">
										<h3 class="text-success">
											<small> EUR </small>
											{{
												Math.trunc(
													this.totalAmountEarnedByBookings
												).toLocaleString("de")
											}},00
										</h3>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="col-sm-6">
						<div class="card">
							<div class="card-body">
								<div class="d-flex col-md-12 mb-3 text-center">
									<div class="avatar-xs mr-3">
										<span
											class="avatar-title rounded-circle bg-info text-primary font-size-18"
										>
											<i class="bx bx-euro bx-tada"></i>
										</span>
									</div>
									<h5 class="font-size-14 mt-2 mb-0">Gutscheineinnahmen</h5>
								</div>
								<div class="mt-2">
									<div class="col-md-12 text-center">
										<h3 class="text-info">
											<small> EUR </small
											>{{
												Math.trunc(
													this.totalAmountEarnedByVouchers
												).toLocaleString("de")
											}},00
										</h3>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="card">
							<div class="card-body text-right">
								<div class="media">
									<div class="media-body align-self-center">
										<div class="text-muted">
											<p class="mb-2">Design & Developed By</p>
											<h5 class="mb-1">AusriLabs</h5>
										</div>
									</div>
									<div class="ml-3">
										<img
											src="@/assets/images/users/Ausrilabs.jpg"
											alt
											class="avatar-md img-thumbnail"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
